<template>
  <normal-layout
      :title="'钱包明细'"
      :content-background-color="'#F0F0F4'"
  >
    <template #left-btn>
      <left-button/>
    </template>
    <template #content>
      <div class="pd-container">
        <div class="pdc-title">
          <p>{{ title }}</p>
          <label>{{ `¥${amount}` }}</label>
        </div>
        <div>
          <span class="margin-top">类型</span>
          <span class="pdc-right">{{ type }}</span>
        </div>
        <div>
          <span>剩余金额</span>
          <span class="pdc-right">{{ `¥${data.balance || 0}` }}</span>
        </div>
        <div>
          <span>到账时间</span>
          <span class="pdc-right">{{ data.transactionDatetime || '' }}</span>
        </div>
        <div>
          <span class="margin-bottom">交易单号</span>
          <span class="pdc-right">{{ data.transactionFlowNumber || '' }}</span>
        </div>
        <div class="pdc-desc">
          <span>描述：</span>
          <span>{{ data.remark }}</span>
        </div>
      </div>
    </template>
  </normal-layout>
</template>

<script>
import NormalLayout from '../../components/actionbar/BasicLayout'
import LeftButton from '../../components/actionbar/TopLeftButton'
import { getParticularsDetail } from '@/request/api.encryptor'
import { Toast } from 'vant'
import { showLoading } from '@/utils/tools'

export default {
  name: 'ParticularsDetail',
  components: {
    NormalLayout,
    LeftButton
  },
  data() {
    return {
      id: 0,
      data: {},
      title: '',
      type: '退款',
      amount: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { id } = this.$route.query || {}
      this.id = id
      this.getDetail()
    })
  },
  methods: {
    getDetail() {
      showLoading('加载中...')
      const params = {
        id: this.id,
        type: '00'
      }
      getParticularsDetail(params)
          .then(res => {
            Toast.clear()
            const { code = 1, msg = '', info = {} } = res || {}
            if (code !== 0) {
              Toast.fail(msg)
              this.goBack()
              return
            }
            this.data = info
            this.dealData()
          })
          .catch(error => {
            Toast.clear()
            Toast.fail(error)
            this.goBack()
          })
    },
    goBack() {
      setTimeout(() => {
        this.$JD.goBack()
      }, 1000)
    },
    dealData() {
      const { transactionType = '0', transactionAmount = '0' } = this.data || {}
      // 0-退款,1-转账,2-支付,3-提现,4-通宝转账
      switch (transactionType) {
        case '0':
          this.title = '退款金额'
          this.type = '退款'
          break
        case '1':
          this.title = '转账金额'
          this.type = '转账'
          break
        case '2':
          this.title = '支付金额'
          this.type = '支付'
          break
        case '3':
          this.title = '提现金额'
          this.type = '提现'
          break
        case '4':
          this.title = '收益转账'
          this.type = '收益转账'
          break
        default:
          this.title = '消费金额'
          this.type = '消费'
          break
      }
      this.amount = parseFloat(transactionAmount)
          .toFixed(2)
      if (parseFloat(transactionAmount) < 0) {
        this.amount = parseFloat(transactionAmount.toString()
            .substr(1))
            .toFixed(2)
      }
    }
  }

}
</script>

<style scoped lang="scss">
.pd-container {
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: .135rem 0.133rem;
    align-items: center;
    background-color: white;

    p {
      color: #525252;
      font-size: .2rem;
    }

    label {
      color: #333333;
      font-size: .4rem;
    }

    span {
      color: #8B8B8B;
      font-size: .173rem;
    }

    .pdc-right {
      color: #6D6D6D;
    }
  }

  .pdc-title {
    padding-top: .427rem;
    padding-bottom: .373rem;
    margin-bottom: .5px;
  }

  .margin-top {
    margin-top: .1rem;
  }

  .margin-bottom {
    margin-bottom: .1rem;
  }

  .pdc-desc {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: .5px;
    padding-top: .227rem;
    padding-bottom: .2rem;
    text-align: left;

    span {
      line-height: .307rem;
    }
  }
}

</style>
